import React, { Fragment } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppA from './components/AppA/AppA';
import AppB from './components/AppB/AppB';
import ThankYou from "./components/ThankYou/ThankYou";
import PaymentFailed from "./components/PaymentFailed/PaymentFailed";
import StepThree from './components/AppB/StepThree';
import { Toaster } from 'react-hot-toast';
import Footer from './components/Footer/Footer';
import PrivacyPolicy from './components/Footer/FooterComponents/PrivacyPolicy';
import RefundPolicy from './components/Footer/FooterComponents/RefundPolicy';
import TermsAndConditions from './components/Footer/FooterComponents/TermsAndConditions';
// import { useTranslation } from 'react-i18next';

// import StepForm from './components/AppB/StepForm';

function App() {
  // const { i18n } = useTranslation();

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  // };

  const countryRoutes = ["us", "uk", "th", "sg","in","ph"];

  return (
    <Router>

      <Toaster />
      {/* Language Selector */}
      {/* <div>
          <button style={{marginRight:"1rem",marginTop:"5px",marginBottom:"5px"}} onClick={() => changeLanguage('en')}>English</button>
          <button style={{marginRight:"1rem",marginTop:"5px",marginBottom:"5px"}} onClick={() => changeLanguage('hn')}>Hindi</button>
          <button style={{marginRight:"1rem",marginTop:"5px",marginBottom:"5px"}} onClick={() => changeLanguage('ta')}>Tamil</button>
        </div> */}
      <Routes>

        {/* Define route for AppA */}

        <Route key={`home`} exact path="/" element={<AppA countryName={"en"} />} />
        <Route key={`survey`} path="/survey-form" element={<AppA countryName={"en"} />} />
        <Route key={`thankyou`} path="/thank-you" element={<ThankYou countryName={"en"} />} />
        <Route key={`payment-failure`} path="/payment-failure" element={<PaymentFailed />} />
        <Route key={`response`} path="/response/:slug" element={<AppB countryName={"en"} />} />
        <Route key={`checkout`} path="/response/checkout/:slug" element={<StepThree countryName={"en"} />} />


        {/* For US  */}
        {/* <Route path="/us" element={<AppA />} />
        <Route path="/us/thank-you" element={<ThankYou isUs={true} />} />
        <Route path="/us/response/:slug" element={<AppB />} />
        <Route path="/us/response/checkout/:slug" element={<StepThree />} /> */}


        {/* For UK  */}

        {/* <Route path="/uk" element={<AppA />} />
        <Route path="/uk/thank-you" element={<ThankYou isUs={true} />} />
        <Route path="/uk/response/:slug" element={<AppB />} />
        <Route path="/uk/response/checkout/:slug" element={<StepThree />} /> */}


        <Route key={`privacy`} path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route key={`refund`} path="/refund-policy" element={<RefundPolicy />} />
        <Route key={`terms`} path="/termsandconditions" element={<TermsAndConditions />} />

         {/* Dynamic Country Routes */}
        {countryRoutes.map((country) => (
          <Fragment key={country}>
            <Route
              key={`${country}-home`}
              path={`/${country}`}
              element={<AppA countryName={country} />}
            />

            <Route
              key={`${country}-thankyou`}
              path={`/${country}/thank-you`}
              element={<ThankYou isUs={true} />}
            />

            <Route
              key={`${country}-response`}
              path={`/${country}/response/:slug`}
              element={<AppB  countryName={country} />}
            />

            <Route
              key={`${country}-checkout`}
              path={`/${country}/response/checkout/:slug`}
              element={<StepThree countryName={country} />}
            />
          </Fragment>
        ))}


      </Routes>
    </Router>
  );
}

export default App;
